export default __webpack_public_path__ + "static/media/location_on.b43212b2.svg";